/**
 * 本文件由 scripts/generate-spm-codes.mjs 生成，请勿手改；编码以评审确认后的 CSV 快照为准。
 * 全局终端：global_pc（由 CSV 页面终端行派生，B 位重写为 global_pc；213 个 D 位坑位，11 个 C 位模块）。
 * 数据源：home_pc（header_tools、primary_navigation、site_notice、site_settings、footer_navigation、footer_help、footer_country_sites、footer_policies、footer_social、footer_subscribe）、product_detail_pc（breadcrumb）。
 * 模块级曝光上报 module.code（A.B.C）；坑位级曝光与点击上报完整编码（A.B.C.D）。
 */
import type { SpmPageCodes } from '../types';
import { getSpmSitePrefix } from '../site';

const sitePrefix = getSpmSitePrefix();

export const GLOBAL_PC_SPM_CODES = {
  breadcrumb: {
    code: `${sitePrefix}.global_pc.breadcrumb`,
    breadcrumb_item_01: `${sitePrefix}.global_pc.breadcrumb.breadcrumb_item_01`,
    breadcrumb_item_02: `${sitePrefix}.global_pc.breadcrumb.breadcrumb_item_02`,
  },
  footer_country_sites: {
    code: `${sitePrefix}.global_pc.footer_country_sites`,
    country_site_entry_001: `${sitePrefix}.global_pc.footer_country_sites.country_site_entry_001`,
    country_site_entry_002: `${sitePrefix}.global_pc.footer_country_sites.country_site_entry_002`,
    country_site_entry_003: `${sitePrefix}.global_pc.footer_country_sites.country_site_entry_003`,
    country_site_entry_004: `${sitePrefix}.global_pc.footer_country_sites.country_site_entry_004`,
    country_site_entry_005: `${sitePrefix}.global_pc.footer_country_sites.country_site_entry_005`,
  },
  footer_help: {
    code: `${sitePrefix}.global_pc.footer_help`,
    open_contact_us: `${sitePrefix}.global_pc.footer_help.open_contact_us`,
    open_market_zeelool_com: `${sitePrefix}.global_pc.footer_help.open_market_zeelool_com`,
    open_track_order: `${sitePrefix}.global_pc.footer_help.open_track_order`,
  },
  footer_navigation: {
    code: `${sitePrefix}.global_pc.footer_navigation`,
    footer_link_01: `${sitePrefix}.global_pc.footer_navigation.footer_link_01`,
    footer_link_02: `${sitePrefix}.global_pc.footer_navigation.footer_link_02`,
    footer_link_03: `${sitePrefix}.global_pc.footer_navigation.footer_link_03`,
    footer_link_04: `${sitePrefix}.global_pc.footer_navigation.footer_link_04`,
    footer_link_05: `${sitePrefix}.global_pc.footer_navigation.footer_link_05`,
    footer_link_06: `${sitePrefix}.global_pc.footer_navigation.footer_link_06`,
    footer_link_07: `${sitePrefix}.global_pc.footer_navigation.footer_link_07`,
    footer_link_08: `${sitePrefix}.global_pc.footer_navigation.footer_link_08`,
    footer_link_09: `${sitePrefix}.global_pc.footer_navigation.footer_link_09`,
    footer_link_10: `${sitePrefix}.global_pc.footer_navigation.footer_link_10`,
    footer_link_11: `${sitePrefix}.global_pc.footer_navigation.footer_link_11`,
    footer_link_12: `${sitePrefix}.global_pc.footer_navigation.footer_link_12`,
    footer_link_13: `${sitePrefix}.global_pc.footer_navigation.footer_link_13`,
    footer_link_14: `${sitePrefix}.global_pc.footer_navigation.footer_link_14`,
    footer_link_15: `${sitePrefix}.global_pc.footer_navigation.footer_link_15`,
    footer_link_16: `${sitePrefix}.global_pc.footer_navigation.footer_link_16`,
    footer_link_17: `${sitePrefix}.global_pc.footer_navigation.footer_link_17`,
    footer_link_18: `${sitePrefix}.global_pc.footer_navigation.footer_link_18`,
    footer_link_19: `${sitePrefix}.global_pc.footer_navigation.footer_link_19`,
    footer_link_20: `${sitePrefix}.global_pc.footer_navigation.footer_link_20`,
    footer_link_21: `${sitePrefix}.global_pc.footer_navigation.footer_link_21`,
    footer_link_22: `${sitePrefix}.global_pc.footer_navigation.footer_link_22`,
    footer_link_23: `${sitePrefix}.global_pc.footer_navigation.footer_link_23`,
    footer_link_24: `${sitePrefix}.global_pc.footer_navigation.footer_link_24`,
    footer_link_25: `${sitePrefix}.global_pc.footer_navigation.footer_link_25`,
    footer_link_26: `${sitePrefix}.global_pc.footer_navigation.footer_link_26`,
    footer_link_27: `${sitePrefix}.global_pc.footer_navigation.footer_link_27`,
    footer_link_28: `${sitePrefix}.global_pc.footer_navigation.footer_link_28`,
    footer_link_29: `${sitePrefix}.global_pc.footer_navigation.footer_link_29`,
    footer_link_30: `${sitePrefix}.global_pc.footer_navigation.footer_link_30`,
    footer_link_31: `${sitePrefix}.global_pc.footer_navigation.footer_link_31`,
    footer_link_32: `${sitePrefix}.global_pc.footer_navigation.footer_link_32`,
    footer_link_33: `${sitePrefix}.global_pc.footer_navigation.footer_link_33`,
    footer_link_34: `${sitePrefix}.global_pc.footer_navigation.footer_link_34`,
    footer_link_35: `${sitePrefix}.global_pc.footer_navigation.footer_link_35`,
    footer_link_36: `${sitePrefix}.global_pc.footer_navigation.footer_link_36`,
    footer_link_37: `${sitePrefix}.global_pc.footer_navigation.footer_link_37`,
    footer_link_38: `${sitePrefix}.global_pc.footer_navigation.footer_link_38`,
    footer_link_39: `${sitePrefix}.global_pc.footer_navigation.footer_link_39`,
    footer_link_40: `${sitePrefix}.global_pc.footer_navigation.footer_link_40`,
    footer_link_41: `${sitePrefix}.global_pc.footer_navigation.footer_link_41`,
    footer_link_42: `${sitePrefix}.global_pc.footer_navigation.footer_link_42`,
    footer_link_43: `${sitePrefix}.global_pc.footer_navigation.footer_link_43`,
    footer_link_44: `${sitePrefix}.global_pc.footer_navigation.footer_link_44`,
    footer_link_45: `${sitePrefix}.global_pc.footer_navigation.footer_link_45`,
    footer_link_46: `${sitePrefix}.global_pc.footer_navigation.footer_link_46`,
    footer_link_47: `${sitePrefix}.global_pc.footer_navigation.footer_link_47`,
    footer_link_48: `${sitePrefix}.global_pc.footer_navigation.footer_link_48`,
    footer_link_49: `${sitePrefix}.global_pc.footer_navigation.footer_link_49`,
    footer_link_50: `${sitePrefix}.global_pc.footer_navigation.footer_link_50`,
    footer_link_51: `${sitePrefix}.global_pc.footer_navigation.footer_link_51`,
    footer_link_52: `${sitePrefix}.global_pc.footer_navigation.footer_link_52`,
    footer_link_53: `${sitePrefix}.global_pc.footer_navigation.footer_link_53`,
    footer_link_54: `${sitePrefix}.global_pc.footer_navigation.footer_link_54`,
    footer_link_55: `${sitePrefix}.global_pc.footer_navigation.footer_link_55`,
    footer_link_56: `${sitePrefix}.global_pc.footer_navigation.footer_link_56`,
    footer_link_57: `${sitePrefix}.global_pc.footer_navigation.footer_link_57`,
    footer_link_58: `${sitePrefix}.global_pc.footer_navigation.footer_link_58`,
    footer_link_59: `${sitePrefix}.global_pc.footer_navigation.footer_link_59`,
    footer_link_60: `${sitePrefix}.global_pc.footer_navigation.footer_link_60`,
    footer_link_61: `${sitePrefix}.global_pc.footer_navigation.footer_link_61`,
    footer_link_62: `${sitePrefix}.global_pc.footer_navigation.footer_link_62`,
    footer_link_63: `${sitePrefix}.global_pc.footer_navigation.footer_link_63`,
    footer_link_64: `${sitePrefix}.global_pc.footer_navigation.footer_link_64`,
    footer_link_65: `${sitePrefix}.global_pc.footer_navigation.footer_link_65`,
    footer_link_66: `${sitePrefix}.global_pc.footer_navigation.footer_link_66`,
    footer_link_67: `${sitePrefix}.global_pc.footer_navigation.footer_link_67`,
    footer_link_68: `${sitePrefix}.global_pc.footer_navigation.footer_link_68`,
    footer_link_69: `${sitePrefix}.global_pc.footer_navigation.footer_link_69`,
    footer_link_70: `${sitePrefix}.global_pc.footer_navigation.footer_link_70`,
    footer_link_71: `${sitePrefix}.global_pc.footer_navigation.footer_link_71`,
    footer_link_72: `${sitePrefix}.global_pc.footer_navigation.footer_link_72`,
    footer_link_73: `${sitePrefix}.global_pc.footer_navigation.footer_link_73`,
    footer_link_74: `${sitePrefix}.global_pc.footer_navigation.footer_link_74`,
    footer_link_75: `${sitePrefix}.global_pc.footer_navigation.footer_link_75`,
    footer_link_76: `${sitePrefix}.global_pc.footer_navigation.footer_link_76`,
    footer_link_77: `${sitePrefix}.global_pc.footer_navigation.footer_link_77`,
  },
  footer_policies: {
    code: `${sitePrefix}.global_pc.footer_policies`,
    policy_entry_01: `${sitePrefix}.global_pc.footer_policies.policy_entry_01`,
    policy_entry_02: `${sitePrefix}.global_pc.footer_policies.policy_entry_02`,
    policy_entry_03: `${sitePrefix}.global_pc.footer_policies.policy_entry_03`,
    policy_entry_04: `${sitePrefix}.global_pc.footer_policies.policy_entry_04`,
    policy_entry_05: `${sitePrefix}.global_pc.footer_policies.policy_entry_05`,
    policy_entry_06: `${sitePrefix}.global_pc.footer_policies.policy_entry_06`,
  },
  footer_social: {
    code: `${sitePrefix}.global_pc.footer_social`,
    social_entry_01: `${sitePrefix}.global_pc.footer_social.social_entry_01`,
    social_entry_02: `${sitePrefix}.global_pc.footer_social.social_entry_02`,
    social_entry_03: `${sitePrefix}.global_pc.footer_social.social_entry_03`,
    social_entry_04: `${sitePrefix}.global_pc.footer_social.social_entry_04`,
    social_entry_05: `${sitePrefix}.global_pc.footer_social.social_entry_05`,
    social_entry_06: `${sitePrefix}.global_pc.footer_social.social_entry_06`,
    social_entry_07: `${sitePrefix}.global_pc.footer_social.social_entry_07`,
  },
  footer_subscribe: {
    code: `${sitePrefix}.global_pc.footer_subscribe`,
    email_input: `${sitePrefix}.global_pc.footer_subscribe.email_input`,
    submit_subscription: `${sitePrefix}.global_pc.footer_subscribe.submit_subscription`,
  },
  header_tools: {
    code: `${sitePrefix}.global_pc.header_tools`,
    cart_entry: `${sitePrefix}.global_pc.header_tools.cart_entry`,
    open_account: `${sitePrefix}.global_pc.header_tools.open_account`,
    open_wishlist: `${sitePrefix}.global_pc.header_tools.open_wishlist`,
    search_input: `${sitePrefix}.global_pc.header_tools.search_input`,
    search_submit: `${sitePrefix}.global_pc.header_tools.search_submit`,
  },
  primary_navigation: {
    code: `${sitePrefix}.global_pc.primary_navigation`,
    logo_entry: `${sitePrefix}.global_pc.primary_navigation.logo_entry`,
    nav_item_05: `${sitePrefix}.global_pc.primary_navigation.nav_item_05`,
    nav_item_06: `${sitePrefix}.global_pc.primary_navigation.nav_item_06`,
    scroll_navigation_next: `${sitePrefix}.global_pc.primary_navigation.scroll_navigation_next`,
    scroll_navigation_previous: `${sitePrefix}.global_pc.primary_navigation.scroll_navigation_previous`,
    submenu_item_01_01: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_01`,
    submenu_item_01_02: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_02`,
    submenu_item_01_03: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_03`,
    submenu_item_01_04: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_04`,
    submenu_item_01_05: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_05`,
    submenu_item_01_06: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_06`,
    submenu_item_01_07: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_07`,
    submenu_item_01_08: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_08`,
    submenu_item_01_09: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_09`,
    submenu_item_01_10: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_10`,
    submenu_item_01_11: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_11`,
    submenu_item_01_12: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_12`,
    submenu_item_01_13: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_13`,
    submenu_item_01_14: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_14`,
    submenu_item_01_15: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_15`,
    submenu_item_01_16: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_16`,
    submenu_item_01_17: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_17`,
    submenu_item_01_18: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_18`,
    submenu_item_01_19: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_19`,
    submenu_item_01_20: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_20`,
    submenu_item_01_21: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_21`,
    submenu_item_01_22: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_22`,
    submenu_item_01_23: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_23`,
    submenu_item_01_24: `${sitePrefix}.global_pc.primary_navigation.submenu_item_01_24`,
    submenu_item_02_01: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_01`,
    submenu_item_02_02: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_02`,
    submenu_item_02_03: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_03`,
    submenu_item_02_04: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_04`,
    submenu_item_02_05: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_05`,
    submenu_item_02_06: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_06`,
    submenu_item_02_07: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_07`,
    submenu_item_02_08: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_08`,
    submenu_item_02_09: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_09`,
    submenu_item_02_10: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_10`,
    submenu_item_02_11: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_11`,
    submenu_item_02_12: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_12`,
    submenu_item_02_13: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_13`,
    submenu_item_02_14: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_14`,
    submenu_item_02_15: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_15`,
    submenu_item_02_16: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_16`,
    submenu_item_02_17: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_17`,
    submenu_item_02_18: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_18`,
    submenu_item_02_19: `${sitePrefix}.global_pc.primary_navigation.submenu_item_02_19`,
    submenu_item_03_01: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_01`,
    submenu_item_03_02: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_02`,
    submenu_item_03_03: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_03`,
    submenu_item_03_04: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_04`,
    submenu_item_03_05: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_05`,
    submenu_item_03_06: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_06`,
    submenu_item_03_07: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_07`,
    submenu_item_03_08: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_08`,
    submenu_item_03_09: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_09`,
    submenu_item_03_10: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_10`,
    submenu_item_03_11: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_11`,
    submenu_item_03_12: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_12`,
    submenu_item_03_13: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_13`,
    submenu_item_03_14: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_14`,
    submenu_item_03_15: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_15`,
    submenu_item_03_16: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_16`,
    submenu_item_03_17: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_17`,
    submenu_item_03_18: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_18`,
    submenu_item_03_19: `${sitePrefix}.global_pc.primary_navigation.submenu_item_03_19`,
    submenu_item_04_01: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_01`,
    submenu_item_04_02: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_02`,
    submenu_item_04_03: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_03`,
    submenu_item_04_04: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_04`,
    submenu_item_04_05: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_05`,
    submenu_item_04_06: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_06`,
    submenu_item_04_07: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_07`,
    submenu_item_04_08: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_08`,
    submenu_item_04_09: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_09`,
    submenu_item_04_10: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_10`,
    submenu_item_04_11: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_11`,
    submenu_item_04_12: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_12`,
    submenu_item_04_13: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_13`,
    submenu_item_04_14: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_14`,
    submenu_item_04_15: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_15`,
    submenu_item_04_16: `${sitePrefix}.global_pc.primary_navigation.submenu_item_04_16`,
  },
  site_notice: {
    code: `${sitePrefix}.global_pc.site_notice`,
    open_help_center: `${sitePrefix}.global_pc.site_notice.open_help_center`,
    open_promotion: `${sitePrefix}.global_pc.site_notice.open_promotion`,
    open_site_settings: `${sitePrefix}.global_pc.site_notice.open_site_settings`,
    track_order: `${sitePrefix}.global_pc.site_notice.track_order`,
  },
  site_settings: {
    code: `${sitePrefix}.global_pc.site_settings`,
    country_option_001: `${sitePrefix}.global_pc.site_settings.country_option_001`,
    country_option_002: `${sitePrefix}.global_pc.site_settings.country_option_002`,
    country_option_003: `${sitePrefix}.global_pc.site_settings.country_option_003`,
    country_option_004: `${sitePrefix}.global_pc.site_settings.country_option_004`,
    country_selector: `${sitePrefix}.global_pc.site_settings.country_selector`,
    currency_option_01: `${sitePrefix}.global_pc.site_settings.currency_option_01`,
    currency_option_02: `${sitePrefix}.global_pc.site_settings.currency_option_02`,
    currency_option_03: `${sitePrefix}.global_pc.site_settings.currency_option_03`,
    currency_option_04: `${sitePrefix}.global_pc.site_settings.currency_option_04`,
    currency_option_05: `${sitePrefix}.global_pc.site_settings.currency_option_05`,
    currency_selector: `${sitePrefix}.global_pc.site_settings.currency_selector`,
    language_option_01: `${sitePrefix}.global_pc.site_settings.language_option_01`,
    language_option_02: `${sitePrefix}.global_pc.site_settings.language_option_02`,
    language_option_03: `${sitePrefix}.global_pc.site_settings.language_option_03`,
    language_option_04: `${sitePrefix}.global_pc.site_settings.language_option_04`,
    language_option_05: `${sitePrefix}.global_pc.site_settings.language_option_05`,
    language_option_06: `${sitePrefix}.global_pc.site_settings.language_option_06`,
    language_option_07: `${sitePrefix}.global_pc.site_settings.language_option_07`,
    language_selector: `${sitePrefix}.global_pc.site_settings.language_selector`,
  },
} as const satisfies SpmPageCodes;
